<template>
  <v-container fluid>
    <v-tabs v-model="tab" align-with-title>
      <v-tab key="payments"> Subscription Issues </v-tab>
      <v-tab key="csv">CSV</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="payments">
        <v-row align="center" justify="center">
          <v-col cols="12" align="center" justify="center">
            <h2>Outstanding Payments - reached max retires</h2>
            <h3>Number of failed payments {{ payments && payments.length }}</h3>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Payment ID</th>
                  <th class="text-left">Customer name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Created at</th>
                  <th class="text-left">Billing Date</th>
                  <th class="text-left">Total Amount</th>
                  <th class="text-left">Total Discount</th>
                  <th class="text-left">Country</th>
                  <th class="text-left">Retries</th>
                  <th class="text-left">Transactions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in payments" :key="payment.node.id">
                  <td>
                    {{ getId(payment.node.id) }}
                  </td>

                  <td>
                    <router-link
                      class="black--text font-weight-bold"
                      :to="`/client-profile/${payment.node.order.user.id}`"
                    >
                      {{ payment.node.order.user.firstName }}
                    </router-link>
                  </td>
                  <td>
                    {{ payment.node.order.user.email }}
                  </td>
                  <td>
                    {{ payment.node.createdAt | moment("YYYY-MM-DD HH:MM") }}
                  </td>
                  <td>
                    {{ payment.node.billingDate }}
                  </td>
                  <td>
                    {{ payment.node.totalAmount }}
                  </td>
                  <td>
                    {{ payment.node.totalDiscount }}
                  </td>
                  <td>
                    {{ payment.node.country }}
                  </td>
                  <td>
                    {{ payment.node.retires }}
                  </td>
                  <td>
                    <span v-for="transaction in payment.node.transactionSet" :key="transaction.id">
                      {{ transaction.transactionStatus }} with code:
                      {{ transaction.gatewayResponse }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" align="center" justify="center">
            <h2>PayFast Payment</h2>
            <h3>
              Number of subscriptions issues
              {{ payfastSubscriptionsWithoutPayments && payfastSubscriptionsWithoutPayments.length }}
            </h3>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Paid Up Until</th>
                  <th class="text-left">Product</th>
                  <th class="text-left">End Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in payfastSubscriptionsWithoutPayments" :key="item.subscription.id">
                  <td>
                    <router-link
                      class="black--text font-weight-bold"
                      :to="
                        '/client-profile/' + item.subscription.user.id + '/manage/subscription/' + item.subscription.id
                      "
                    >
                      {{ item.subscription.user.firstName ? item.subscription.user.firstName : "Name missing" }}
                      {{ item.subscription.user.lastName }}
                    </router-link>
                  </td>
                  <td>
                    {{ item.subscription.user.email }}
                  </td>
                  <td>
                    {{ item.paidUpUntil }}
                  </td>
                  <td>
                    {{ item.subscription.product.type }}
                  </td>
                  <td>
                    {{ item.subscription.endDate }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="csv">
        <v-row align="center" justify="center">
          <v-col cols="6" class="pl-8">
            <v-btn
              color="primary"
              :disabled="startDate == null || endDate == null"
              @click="downloadPaymentReport"
              :loading="reconLoading"
              >Download Payments Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="primary"
              :disabled="startDate == null || endDate == null"
              @click="downloadServedClientsReport"
              :loading="reconLoading"
              >Download served clients Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6" class="pl-8">
            <v-btn
              color="primary"
              :disabled="startDate == null || endDate == null"
              :loading="xeroLoading"
              @click="downloadXeroReport('payments')"
              >Download Xero Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="primary"
              :disabled="startDate == null || endDate == null"
              :loading="xeroLoading"
              @click="downloadXeroReport('refunds')"
              >Download Xero Refund Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6" class="pl-8">
            <v-btn
              color="primary"
              :disabled="startDate == null || endDate == null"
              :loading="xeroLoading"
              @click="downloadXeroReport('discounts')"
              >Download Xero Discounts Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" :loading="brandRetentionLoading" @click="sendBrandRetentionData()"
              >Download Brand Retention Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6" class="pl-8">
            <v-btn
              color="primary"
              :disabled="startDate == null || endDate == null"
              :loading="subscriptionLoading"
              @click="sendSubscriptionData()"
              >Download Subscription Report</v-btn
            >
            <h5 class="mt-3">
              Getting this csv will take some time depending on the size of your date range
            </h5>
          </v-col>
          <v-col cols="6">&nbsp;</v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import {
  PAYFAST_SUBSCRIPTIONS_WITHOUT_PAYMENTS_QUERY,
  XERO_REPORT_QUERY,
  XERO_REFUND_REPORT_QUERY,
  XERO_DISCOUNT_REPORT_QUERY,
  PAYMENTS_EXPORT_REPORT_QUERY,
  SERVED_CLIENTS_REPORT_QUERY,
  SEND_BRAND_RETENTION_QUERY,
  SEND_SUBSCIRPTION_REPORT_QUERY,
} from "@/constants/graphql/billing/billing";
import { PAYMENTS_QUERY } from "@/constants/graphql/billing/payments";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";

export default {
  name: "PaymentReporting",
  mixins: [FileDownloadMixin],
  components: {},
  props: {
    startDate: {
      type: String,
    },

    endDate: {
      type: String,
    },
  },
  data() {
    return {
      tab: "payments",
      payments: null,
      successfulPayments: null,
      payfastSubscriptionsWithoutPayments: null,
      reconLoading: false,
      xeroLoading: false,
      brandRetentionLoading: false,
      subscriptionLoading: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.getters.user.isSuperuser) {
        vm.$router.push("/reporting/billing");
      }
    });
  },
  methods: {
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
    downloadXeroReport(type = "payments") {
      this.xeroLoading = true;
      let map = {
        payments: XERO_REPORT_QUERY,
        refunds: XERO_REFUND_REPORT_QUERY,
        discounts: XERO_DISCOUNT_REPORT_QUERY,
      };
      let queryType = map[type];
      this.$apollo
        .query({
          query: queryType,
          fetchPolicy: "no-cache",
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.xeroLoading = false;
            let fname = `${this.startDate}_${this.endDate}_xero.csv`;
            let dataString = "";
            switch (type) {
              case "payments":
                dataString = data.data.adminXeroReport;
                break;
              case "refunds":
                dataString = data.data.adminXeroRefundReport;
                break;
              case "discounts":
                dataString = data.data.adminXeroDiscountReport;
                break;
            }
            this.downloadBase64File("application/csv", dataString, fname);
          }
        });
    },
    downloadPaymentReport() {
      this.reconLoading = true;
      this.$apollo
        .query({
          query: PAYMENTS_EXPORT_REPORT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.reconLoading = false;
            this.$toasted.success("The report will be emailed to you. This may take up to 10 minutes. ", {
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    downloadServedClientsReport() {
      this.reconLoading = true;
      this.$apollo
        .query({
          query: SERVED_CLIENTS_REPORT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.reconLoading = false;
            this.$toasted.success("The report will be emailed to you. This may take up to 10 minutes. ", {
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    async sendBrandRetentionData() {
      this.brandRetentionLoading = true;
      const result = await this.$apollo.query({
        query: SEND_BRAND_RETENTION_QUERY,
        fetchPolicy: "no-cache",
      });
      this.brandRetentionLoading = false;
      if (result.data?.sendBrandRetention) {
        this.$toasted.success("The report will be emailed to you. This may take up to 10 minutes. ", {
          duration: 2000,
          position: "bottom-center",
        });
      }
    },
    async sendSubscriptionData() {
      this.subscriptionLoading = true;
      const result = await this.$apollo.query({
        query: SEND_SUBSCIRPTION_REPORT_QUERY,
        fetchPolicy: "no-cache",
        variables: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
      });
      this.subscriptionLoading = false;
      if (result.data?.sendSubscriptionReport) {
        this.$toasted.success("The report will be emailed to you. This may take up to 10 minutes. ", {
          duration: 2000,
          position: "bottom-center",
        });
      }
    },
  },
  apollo: {
    payments: {
      query: PAYMENTS_QUERY,
      variables() {
        return {
          billingDate_Gte: this.startDate,
          billingDate_lte: this.endDate,
          paymentStatus: "FAILED",
          retries: 5,
        };
      },
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
      update(data) {
        return data.payments.edges;
      },
    },
    successfulPayments: {
      query: PAYMENTS_QUERY,
      variables() {
        return {
          billingDate_Gte: this.startDate,
          billingDate_lte: this.endDate,
          paymentStatus: "SUCCESS",
        };
      },
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
      update(data) {
        return data.payments.edges;
      },
    },
    payfastSubscriptionsWithoutPayments: {
      query: PAYFAST_SUBSCRIPTIONS_WITHOUT_PAYMENTS_QUERY,
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
